/**
 * Conteúdo estático da LP de inscrição do SOS Aprova 2026 (rota /).
 * Porte da landing /sos-aprova do projeto de LPs (wisereducacao-landing-pages).
 *
 * Captação para a revisão pré-Enem ao vivo do Aprova Total, de 02 a 14/11.
 * Copy do doc "Copy LP SOS Aprova 2026 · Captação" e do Claude Design
 * "LP SOS Aprova 2026 FINAL" (ver _design/sos-aprova/).
 * Visual: TV retrô na praia (azul Aprova, amarelo, laranja, grão e scanlines).
 */

/** Início do SOS (horário de Brasília). Alimenta a contagem e o JSON-LD. */
export const SOS_INICIO_ISO = "2026-11-02T00:00:00-03:00";
export const SOS_FIM_ISO = "2026-11-14T23:59:59-03:00";

/**
 * Formulário 382 do ActiveCampaign (embed passado pelo Rodrigo em 02/10/2026),
 * enviado por JSONP sem o script do AC, igual ao Craques do Enem.
 * Campos do form: fullname, email, phone, field[28] "Interesses e objetivos
 * de estudo" (select obrigatório) e os hidden de UTM.
 */
export const AC_FORM_ID = "382";
export const AC_OR = "3cb046ae-e60b-4f94-8b71-ab81b2c80e70";
/** Custom fields do form 382 (window.cfields do embed). */
export const AC_FIELDS = { interesses: 28, utm_term: 219, utmcampaign: 195, utm_source: 190, utm_medium: 176, utm_content: 175 };

/** Grupo do WhatsApp (Sendflow) para onde a pessoa vai depois da inscrição.
 * Link passado pelo Rodrigo em 05/10/2026. */
export const WHATSAPP_URL = "https://sndflw.com/i/suhfOMVYJBsEkWO9BVSC";

/** Evento da inscrição no /leads (vira evento no ActiveCampaign) e no /dashboard/lp. */
export const LEAD_EVENT = "sos-aprova-2026";

const INSCRICAO = "#inscricao";

export const sosContent = {
  selos: [
    { label: "02 A 14/11", tone: "amarelo", blink: false },
    { label: "AULÕES AO VIVO", tone: "laranja", blink: true },
    { label: "100% GRATUITO", tone: "ceu", blink: false },
  ],

  hero: {
    logoAprovaAlt: "Aprova Total",
    logoSosAlt: "SOS Aprova",
    h1: { pre: "A maior revisão pré-Enem do Aprova ", hl: "já tem data" },
    paragrafo: {
      pre: "São ",
      b: "duas semanas com os professores do Aprova Total",
      post: ", pensadas pra você revisar os conteúdos mais importantes, descontrair com a galera e chegar ao Enem com a energia lá no alto!",
    },
    kvAlt: "Praia ao pôr do sol com estética de TV antiga, campanha SOS Aprova",
  },

  form: {
    tag: "INSCRIÇÃO",
    titulo: "Garanta seu lugar no SOS",
    campos: {
      nome: { label: "Nome", placeholder: "Seu nome completo" },
      email: { label: "E-mail", placeholder: "voce@email.com" },
      whatsapp: { label: "WhatsApp", placeholder: "(00) 00000-0000" },
      /** field[28] do AC: os valores precisam bater com as opções do select do form 382. */
      objetivo: {
        label: "Interesses e objetivos de estudo",
        placeholder: "Escolha uma opção",
        opcoes: [
          "Entrar em Medicina pelo Enem",
          "Entrar em Medicina por vestibular tradicional",
          "Entrar em um curso pelo Enem",
          "Entrar em um curso por vestibular tradicional",
          "Não sou vestibulando",
        ],
      },
    },
    cta: "Quero me inscrever de graça",
    rodape: "O SOS é gratuito do começo ao fim.",
    erros: {
      nome: "Digite seu nome.",
      email: "Digite um e-mail válido.",
      whatsapp: "Digite um WhatsApp válido, com DDD.",
      objetivo: "Escolha uma opção.",
      envio: "Não deu pra enviar agora. Tenta de novo em alguns segundos?",
    },
    sucesso: {
      titulo: "Inscrição confirmada!",
      texto: "Agora entra no grupo do WhatsApp: é por lá que chegam a programação, os links de cada aulão e os lembretes.",
      cta: "Entrar no grupo do WhatsApp",
    },
  },

  ticker: ["02 A 14/11", "AULÕES AO VIVO", "100% GRATUITO", "Aulões ao vivo especiais para a reta final"],

  contagem: { pre: "Faltam", unidades: ["dias", "horas", "min", "seg"], post: ["pro SOS", "entrar no ar"] },

  beneficios: {
    h2: "Muito mais que uma simples revisão",
    lead: { pre: "É o ", b: "Aprova ao vivo com você", post: ", pra viver a reta final com mais calma e chegar à prova confiante no que estudou." },
    sub: "Você também recebe:",
    itens: [
      { label: "Materiais gratuitos", icon: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" },
      { label: "Simulados no padrão ENEM", icon: "M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2 M9 14l2 2 4-4" },
      { label: "Dicas para resolver a prova com tranquilidade", icon: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5 M9 18h6 M10 22h4" },
      { label: "Estratégia de resolução de questão", icon: "M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z M12 6a6 6 0 1 0 0 12a6 6 0 1 0 0-12z M12 10a2 2 0 1 0 0 4a2 2 0 1 0 0-4z" },
      { label: "Resolução comentada por professores", icon: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z M8 9h8 M8 13h5" },
      { label: "Simulador TRI exclusivo pós-prova", icon: "M3 3v16a2 2 0 0 0 2 2h16 M18 17V9 M13 17V5 M8 17v-3" },
    ],
    card: {
      fotoAlt: "Professor do Aprova com camiseta SOS na praia",
      titulo: "Garanta seu lugar no SOS",
      cta: "Quero me inscrever de graça",
      rodape: "O SOS é gratuito do começo ao fim.",
    },
  },

  /**
   * 3ª dobra "Programação" (handoff de 19/10/2026). A grade ainda pode mudar:
   * para trocar horário, professor ou disciplina, mexa só nestes dados.
   * `convidado: true` pinta o nome e o anel do avatar de amarelo.
   * Foto: `foto` é o nome do arquivo em /images/sos-aprova/profs (sem
   * extensão); sem foto, aparecem as iniciais.
   */
  programacao: {
    h2: "Esse é o time de professores que vai te proporcionar a maior revisão pré-Enem do ano!",
    sub: "As melhores estratégias, dicas, conteúdos, vão ser liberadas por eles",
    convidadosTitulo: "Participações especiais",
    heroLink: "+ participações especiais",
    convidados: [
      { selo: "SÁB 14/11 · 10H", nome: "Sandro Curió", disciplina: "Matemática", frase: "Bora, friend: rumo ao topo na matemática!", foto: "sandro-curio" },
      { selo: "SÁB 14/11 · 14H", nome: "Thales Quirino", disciplina: "Física", frase: "Fisiquei: aprenda Física de verdade.", foto: "thales-quirino" },
      { selo: "SÁB 14/11 · 13H", nome: "Marcelão", disciplina: "Química", frase: "Senta que lá vem história… de Química.", foto: "marcelao" },
      { selo: "SÁB 07/11 · 14H", nome: "Deco Duarte", disciplina: "Português e Literatura", frase: "Linguagem em questão: a prova fica quase óbvia.", foto: "deco-duarte" },
      { selo: "SÁB 07/11 · 10H", nome: "Luma", disciplina: "Redação", frase: "Nada de ilusão: é redação 900+ e ponto.", foto: "luma" },
      { selo: "SÁB 07/11 · 15H", nome: "Claudio Hansen", disciplina: "Geopolítica e Atualidades", frase: "Tem fofoca geopolítica na área.", foto: "claudio-hansen" },
      { selo: "SÁB 07/11 · 11H", nome: "Carol Mendonça", disciplina: "Português", frase: "Chega de sofrer: é bizu de português pra desesperados.", foto: "carol-mendonca" },
    ],
    /** Avatares da grade, pela chave do nome (minúsculo, sem acento). */
    avatares: {
      alan: "av-alan", ana: "av-ana", bruno: "av-bruno", camila: "av-camila", dani: "av-dani", dudu: "av-dudu",
      grego: "av-grego", gustavo: "av-gustavo", jubilut: "av-jubilut", matheus: "av-matheus", naza: "av-naza",
      nilo: "av-nilo", piu: "av-piu", ricardinho: "av-ricardinho", thiago: "av-thiago", vava: "av-vava",
      "sandro-curio": "av-sandro-curio", marcelao: "marcelao", "thales-quirino": "thales-quirino",
      luma: "av-luma", "carol-mendonca": "av-carol-mendonca", "claudio-hansen": "av-claudio-hansen", "deco-duarte": "av-deco-duarte",
    },
    gradeTitulo: "Programação",
    sabadoSelo: "SÁBADO ESPECIAL",
    sabadoTexto: "Maratona com os convidados",
    simuladosSelo: "SIMULADOS DA SEMANA",
    semanas: [
      {
        num: "SEMANA 1",
        curto: "Linguagens e Humanas",
        dias: [
          { dow: "SEG", data: "02/11", aulas: [["18h", "Dudu", "Geografia"], ["18h45", "Thiago", "Filosofia"], ["19h30", "Bruno", "História"], ["20h15", "Camila", "Literatura"]] },
          { dow: "TER", data: "03/11", aulas: [["18h", "Alan", "História"], ["18h45", "Thiago", "Sociologia"], ["19h30", "Ricardinho", "Português"], ["20h15", "Dani", "Redação"]] },
          { dow: "QUA", data: "04/11", aulas: [["18h", "Alan e Dudu", "História e Geografia"], ["18h45", "Dani", "Redação"], ["19h30", "Dudu", "Geografia"], ["20h15", "Ricardinho e Camila", "Português e Literatura"]] },
          {
            dow: "SÁB", data: "07/11",
            aulas: [["10h", "Luma", "Redação", true], ["11h", "Carol Mendonça", "Português", true], ["12h", "Ricardinho", "Português"], ["13h", "Alan", "História"], ["14h", "Deco Duarte", "Português e Literatura", true], ["15h", "Claudio Hansen", "Geopolítica e Atualidades", true], ["16h", "Dudu", "Geografia"], ["17h", "Camila", "Literatura"], ["18h", "Thiago", "Filosofia e Sociologia"]],
          },
        ],
        simulados: [{ area: "Linguagens", abre: "05/11", fecha: "08/11" }, { area: "Ciências Humanas", abre: "06/11", fecha: "08/11" }],
      },
      {
        num: "SEMANA 2",
        curto: "Natureza e Matemática",
        dias: [
          { dow: "SEG", data: "09/11", aulas: [["18h", "Jubilut", "Biologia"], ["18h45", "Jubilut", "Biologia"], ["19h30", "Piu", "Matemática"], ["20h15", "Matheus", "Física"]] },
          { dow: "TER", data: "10/11", aulas: [["18h", "Piu", "Matemática"], ["18h45", "Nilo", "Física"], ["19h30", "Ana", "Química"], ["20h15", "Naza", "Matemática"]] },
          { dow: "QUA", data: "11/11", aulas: [["18h", "Gustavo e Ana", "Biologia e Química"], ["18h45", "Ana", "Química"], ["19h30", "Gustavo", "Biologia"], ["20h15", "Nilo", "Física"]] },
          {
            dow: "SÁB", data: "14/11",
            aulas: [["10h", "Sandro Curió", "Matemática", true], ["11h", "Gustavo", "Biologia"], ["12h", "Piu", "Matemática"], ["13h", "Marcelão", "Química", true], ["14h", "Thales Quirino", "Física", true], ["15h", "Jubilut", "Biologia"], ["16h", "Vavá", "Matemática"], ["17h", "Grego", "Física"], ["18h", "Ana", "Química"]],
          },
        ],
        simulados: [{ area: "Ciências da Natureza", abre: "12/11", fecha: "15/11" }, { area: "Matemática", abre: "13/11", fecha: "15/11" }],
      },
    ],
    cta: {
      texto: "Duas semanas de revisão ao vivo pra você parar de se cobrar pelo que não estudou e focar no que ainda pode fazer diferença.",
      botao: "Quero entrar no SOS",
      href: INSCRICAO,
      capivaraAlt: "Capivara do SOS fazendo joinha",
    },
  },

  provaSocial: {
    h2: "Quem já acompanhou o SOS conta",
    imgAlt: "Comentário de aluno sobre o SOS",
    anterior: "Depoimento anterior",
    proximo: "Próximo depoimento",
    irPara: "Ir para o depoimento",
    /** Ordem do design. Dimensões reais de cada arquivo (public/images/sos-aprova). */
    slides: [
      ["comentario-1", 448, 238], ["img-4089", 651, 1076], ["img-4074", 498, 285], ["img-4096", 494, 326],
      ["comentario-3", 261, 146], ["img-4093", 572, 319], ["img-4075", 510, 300], ["img-4085", 528, 302],
      ["img-4076", 438, 289], ["img-4094", 550, 344], ["img-4077", 416, 313], ["img-4086", 512, 312],
      ["img-4078", 532, 312], ["img-4087", 522, 309], ["img-4079", 548, 334], ["img-4088", 532, 323],
      ["img-4080", 504, 292], ["img-4090", 498, 326], ["img-4084", 530, 293], ["img-4091", 558, 301],
      ["img-4092", 408, 267], ["img-4095", 478, 306],
    ],
    numeros: [
      { valor: "405", label: "aprovações em Medicina no SISU 2025" },
      { valor: "7", label: "redações nota 1.000 no Enem" },
      { valor: "+18 mil", label: "aprovações de alunos do Aprova" },
    ],
  },

  faq: {
    h2: "Perguntas frequentes",
    itens: [
      { q: "O SOS é pago?", a: "Não. O SOS é gratuito do começo ao fim. É só se inscrever." },
      { q: "Pra quem o SOS Aprova é indicado?", a: "Pra quem vai fazer o Enem e quer organizar a reta final com quem entende da prova. Serve tanto pra quem estudou o ano todo e quer revisar com foco quanto pra quem sente que ainda tem pontos a ajustar e quer saber por onde começar." },
      { q: "Vou prestar o Enem só em 2027. Posso participar?", a: "Pode. Acompanhar o SOS agora te dá uma boa noção de como a prova funciona e do que ela mais cobra, e isso já ajuda a planejar o seu próximo ano." },
      { q: "Como faço para receber as atualizações e informações sobre o evento?", a: "É só se inscrever nesta página e entrar no grupo do WhatsApp que aparece logo depois da inscrição. Por lá e pelo seu e-mail, você recebe a programação, os links de cada aulão e os lembretes antes de cada live." },
      { q: "Como acesso os aulões, os materiais e os simulados?", a: "Os links dos aulões chegam por e-mail e pelo grupo do WhatsApp antes de cada live." },
      { q: "Como funciona a TRI?", a: "A TRI, ou Teoria de Resposta ao Item, é o método que o Enem usa pra calcular a sua nota. Ela não conta só quantas questões você acertou, mas também quais: acertar as fáceis e errar as difíceis mostra um padrão coerente, e isso pesa a seu favor. Por isso, duas pessoas com o mesmo número de acertos podem ter notas diferentes. Depois da prova, você pode usar o simulador TRI do Aprova: é só inserir as suas respostas pra ver uma estimativa da sua nota no Enem." },
      { q: "Quando sai a programação?", a: "Em breve. Quem está inscrito recebe primeiro, por e-mail e WhatsApp." },
      { q: "Posso tirar dúvidas durante o aulão?", a: "Pode, e vale muito a pena. O SOS é ao vivo justamente pra você ter contato direto com os professores do Aprova. Manda a sua dúvida no chat durante a live que eles respondem ali mesmo, junto com a explicação." },
    ],
  },

  rodape: { logoAlt: "Aprova Total", tagline: "Conhecimento máximo. Tempo mínimo." },

  barra: { pre: "Faltam", cta: "Inscrever de graça", href: INSCRICAO },

  /** Resposta direta (AEO/GEO): entity-first, usada no JSON-LD e na description. */
  resumo:
    "O SOS Aprova 2026 é a revisão pré-Enem gratuita e ao vivo do Aprova Total: duas semanas de aulões com os professores da plataforma, de 2 a 14 de novembro de 2026, com materiais gratuitos, simulados no padrão Enem, estratégia de resolução de questões, resolução comentada e simulador TRI pós-prova. A inscrição é gratuita e os links chegam por e-mail e pelo grupo do WhatsApp.",
};
